module.exports = __webpack_public_path__ + "static/media/brainflix-macbook-hero-one.4690863c.jpg";